import { APP_TARGET } from "./config";
import { useAuth } from "./auth";
import { LoginScreen } from "./components/LoginScreen";
import { LoadingScreen } from "./components/Shared";
import { CustomerApp } from "./customer/CustomerApp";
import { AdminApp } from "./admin/AdminApp";

export function App() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <LoginScreen />;
  return APP_TARGET === "customer" ? <CustomerApp /> : <AdminApp />;
}
